<script setup lang="ts">
  import {computed, ref, onBeforeMount} from 'vue';
  import {getComponentConfig} from '@core/utils/getComponentConfig';

  interface Props {
    lines?: number | string;
    class?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    lines: undefined,
    class: '',
  });

  const defaultConfig = {
    base: 'text-sm font-medium text-gray-900 dark:text-gray-100',
  };

  const config = ref(defaultConfig);

  onBeforeMount(async () => {
    config.value = await getComponentConfig('ListItemTitle', defaultConfig);
  });

  const LINE_CLAMP: Record<number, string> = {
    2: 'line-clamp-2',
    3: 'line-clamp-3',
    4: 'line-clamp-4',
    5: 'line-clamp-5',
    6: 'line-clamp-6',
  };

  const linesClass = computed(() => {
    if (props.lines == null || props.lines === '') return 'truncate';
    const l = Number(props.lines);
    if (!Number.isFinite(l) || l < 1) return 'truncate';
    const clamped = Math.min(6, Math.max(1, Math.floor(l)));
    if (clamped === 1) return 'truncate';
    return LINE_CLAMP[clamped] ?? 'line-clamp-2';
  });
</script>

<template>
  <div :class="['list__item-title', config.base, linesClass, props.class]">
    <slot />
  </div>
</template>
